var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.979004 2.5C0.979004 1.60083 1.70484 0.875 2.604 0.875C3.50317 0.875 4.229 1.60083 4.229 2.5C4.229 3.39917 3.50317 4.125 2.604 4.125C1.70484 4.125 0.979004 3.39917 0.979004 2.5ZM0.979167 9C0.979167 8.10083 1.705 7.375 2.60417 7.375C3.50333 7.375 4.22917 8.10083 4.22917 9C4.22917 9.89917 3.50333 10.625 2.60417 10.625C1.705 10.625 0.979167 9.89917 0.979167 9ZM2.60417 13.875C1.705 13.875 0.979167 14.6117 0.979167 15.5C0.979167 16.3883 1.71583 17.125 2.60417 17.125C3.4925 17.125 4.22917 16.3883 4.22917 15.5C4.22917 14.6117 3.50333 13.875 2.60417 13.875ZM21.0208 16.5833H5.85417V14.4167H21.0208V16.5833ZM5.85417 10.0833H21.0208V7.91667H5.85417V10.0833ZM5.85417 3.58333V1.41667H21.0208V3.58333H5.85417Z",
    fill: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuList);
export default __webpack_public_path__ + "static/media/menu-list.4ae21d14901796302a83dba55c912fef.svg";
export { ForwardRef as ReactComponent };